<template>
  <div>
    <div
      v-for="category of categories"
      :key="category.title"
    >
      <v-expansion-panels accordion>
        <v-expansion-panel
          v-if="category.children"
        >
          <v-expansion-panel-header class="pl-0 pr-4 py-0">
            <v-list
              dense
              shaped
            >
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>{{ category.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ category.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list
              dense
              shaped
            >
              <template
                v-for="child of category.children"
              >
                <v-list-item
                  v-if="can(child.action)"
                  :key="child.title"
                  :to="{name: child.route}"
                >
                  <v-list-item-icon>
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    {{ child.title }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-list
        v-if="!category.children && can(category.action)"
        dense
        shaped
      >
        <v-list-item
          :to="{name: category.route}"
        >
          <v-list-item-icon>
            <v-icon>{{ category.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ category.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Actions from '@/data/Permissions/enums.json'

import { USER_NAMESPACE } from '@/store/user'

export default {
  name: 'SettingsNav',

  data () {
    return {
      categories: [
        { action: Actions.Platform.Settings.ViewSiteSettings, icon: 'mdi-cog', route: 'settings-site', title: 'Site' },
        { action: Actions.Platform.Settings.ViewAuth, icon: 'security', route: 'settings-auth', title: 'Auth' },
        { action: Actions.Platform.Settings.ViewChecklists, icon: 'checklist', route: 'settings-checklists', title: 'Checklists' },
        { action: Actions.Platform.Settings.ViewIntegrations, icon: 'stream', route: 'settings-integration', title: 'Integrations' },
        { action: Actions.Platform.Settings.ViewTags, icon: 'tag', route: 'settings-shared-tags', title: 'Tags' },
        { action: Actions.Platform.Settings.ViewLawlabSubscription, icon: 'mdi-alpha-s-box-outline', route: 'settings-subscription', title: 'Law Lab Subscription' },
        {
          children: [
            { action: Actions.Platform.Settings.ViewUsers, icon: 'account_box', route: 'settings-user-list', title: 'Users' },
            { action: Actions.Platform.Settings.ViewUserTeamMembership, icon: 'account_box', route: 'settings-user-memberships', title: 'User Memberships' },
            { action: Actions.Platform.Settings.ViewUserGroups, icon: 'mdi-account-group', route: 'settings-user-groups', title: 'User Groups' },
            { action: Actions.Platform.Settings.ViewTeams, icon: 'groups', route: 'settings-teams', title: 'Teams' },
          ],

          icon: 'person',
          route: 'settings-users',
          title: 'User & Teams',
        },
        {
          children: [
            { action: Actions.Platform.Settings.ViewUsers, icon: 'mdi-shield-account', route: 'settings-platform-roles-list', title: 'Platform Roles' },
            { action: Actions.Platform.Settings.ViewUsers, icon: 'mdi-shield-account', route: 'settings-platform-roles-matrix', title: 'Platform Roles - Matrix' },
            { action: Actions.Platform.Settings.ViewUsers, icon: 'mdi-shield-account', route: 'settings-platform-permission-check', title: 'Permission Checker' },
          ],

          icon: 'person',
          route: 'settings-users',
          title: 'Roles & Permissions',
        },
        {
          children: [
            { action: Actions.Platform.Settings.ViewPartyLanguages, icon: 'language', route: 'settings-party-languages', title: 'Languages' },
            { action: Actions.Platform.Settings.ViewPartyEthnicities, icon: 'language', route: 'settings-party-ethnicities', title: 'Ethnicities' },
            { action: Actions.Platform.Settings.ViewPartyRoles, icon: 'badge', route: 'settings-party-roles', title: 'Roles' },
            { action: Actions.Platform.Settings.ViewQuickInterviewSettings, icon: 'mdi-account-voice', route: 'settings-quick-interview', title: 'Quick Interview' },
          ],

          icon: 'person',
          route: 'settings-party',
          title: 'Party',
        },
        {
          children: [
            { action: Actions.Platform.Settings.ViewLegalCaseTypes, icon: 'assignment', route: 'settings-legal-case-types', title: 'Case Types' },
            { action: Actions.Platform.Settings.ViewLegalCaseLocations, icon: 'place', route: 'settings-legal-case-locations', title: 'Locations' },
            { action: Actions.Platform.Settings.ViewLegalCasePreferenceCategories, icon: 'assignment_ind', route: 'settings-legal-case-preference-categories', title: 'Preference Categories' },
            { action: Actions.Platform.Settings.ViewLegalCaseClosingReasons, icon: 'archive', route: 'settings-legal-case-closing-reasons', title: 'Closing Reasons' },
            { action: Actions.Platform.Settings.ViewEngagementLetter, icon: 'mdi-script-text-outline', route: 'settings-legal-case-engagement-letter-templates', title: 'Engagement Letter Templates' },
            { action: Actions.Platform.Settings.ViewLegalCaseOther, icon: 'settings_suggest', route: 'settings-legal-case-other', title: 'Other' },
          ],

          icon: 'work',
          route: 'settings-legal-cases',
          title: 'Legal Cases',
        },
        {
          children: [
            { action: Actions.Platform.Settings.ViewDocketEntryTypes, icon: 'library_add_check', route: 'settings-docket-entry-types', title: 'Entry Types' },
            { action: Actions.Platform.Settings.ViewDocketEntryDocumentSets, icon: 'content_copy', route: 'settings-docket-entry-document-sets', title: 'Document Sets' },
            { action: Actions.Platform.Settings.ViewDocketEntryNotificationTemplates, icon: 'mdi-script-text', route: 'settings-docket-entry-notification-template', title: 'Notification Templates' },
            { action: Actions.Platform.Settings.ViewDocketEntryAppointmentLocations, icon: 'place', route: 'settings-docket-entry-appointment-locations', title: 'Appointment Locations' },
            { action: Actions.Platform.Settings.ViewDocketEntryOther, icon: 'settings_suggest', route: 'settings-docket-entry-other', title: 'Other' },
          ],

          icon: 'check_circle_outline',
          route: 'settings-docket-entries',
          title: 'Docket Entries',
        },
      ],
    }
  },

  computed: {
    categoriesWithChildren () {
      return this.categories.filter(c => c.children)
    },

    ...mapGetters(USER_NAMESPACE, [
      'can',
    ]),
  },

  methods: {
    navigateTo (category) {
      if (category.active) return

      this.$router.push({ name: category.route })
    },
  },
}
</script>

<style scoped lang="scss">
  .d-sticky {
    position: sticky !important;
    top: 72px !important;
    z-index: 1 !important;
  }
</style>
